<template>
  <div class="dashboard-promo-banner-delete" :class="{ open: isOpen }">
      <div class="banner--content">
          <div class="banner-content-wrap">
              <div class="banner--content__left">
                  <div class="promo">
                      <div>
                          <span v-translate>Set your own logo and accountant color.</span>
                      </div>
                  </div>
              </div>
              <div class="banner--content__right">
                  <GekkoButton :text="$gettext('Settings')" :href="Urls['accounts_manage_companies']()" />
              </div>
          </div>
      </div>
  </div>
</template>
  
  <script>
    import { mapGetters } from "vuex";
    import FlipCount from "@/components/dashboard/ui/FlipCount"
    import GekkoButton from "@/components/GekkoButton.vue";

    export default {
        name: "SetColorAndLogoReminder",
        components: {
            FlipCount,
            GekkoButton
        },
        data () {
            return {
                isOpen: false,
                promoEnds: null,
                bannerType: null,
                debug: false
            }
        },
        computed: {
            bannerLink () {
                return '/subscriptions/manage/?selected=year'
            },
            ...mapGetters({
                currentUser: "main/getCurrentUser"
            })
        },
        created () {
            
        },
        mounted () {
            setTimeout(() => {
                this.isOpen = true
            }, 1000)
        },
        methods: {
        
        }
    }
  </script>
  <style scoped lang="scss">
    .dashboard-promo-banner-delete {
      max-height: 120px;
      cursor: auto !important;
      display: flex;
      align-items: center;
      background: linear-gradient(103deg, #b3870e, #68310d) !important;
      height: 0px;
      // overflow: hidden;
      overflow: visible;
      transition: height 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      margin-bottom: 0.5rem;
      border-radius: 12px;
      margin-left: 1rem;
      margin-right: 1rem;
  
      .banner-price-tag {
        &:before {
          bottom: -2px;
          height: 2px;
        }
      }
  
      .banner--content {
        &:hover {
          text-decoration: none;
        }
        display: flex; 
        padding: 0.75rem;
        font-weight: 900; 
        flex-direction: column; 
        justify-content: center; 
        width: 100%; 
        // max-width: 80rem; 
        height: 100%; 
  
        @media (min-width: 640px) { 
          padding-left: 1.5rem;
          padding-right: 1.5rem; 
        }
  
        @media (min-width: 1024px) { 
          padding-left: 2rem;
          padding-right: 2rem; 
        }
  
        transition: all 0.5s cubic-bezier(0.750, 0.020, 0.190, 1.290);
        opacity: 0;
        transform: scale(0.9);
        .banner-content-wrap {
          display: flex; 
          flex-wrap: wrap; 
          justify-content: space-between; 
          align-items: center; 
        }
        &__left {
          display: flex; 
          flex-direction: column; 
          align-items: center; 
          justify-content: space-evenly;
          width: 100%; 
  
          @media (min-width: 640px) { 
            flex-direction: row; 
            flex: 1 1 0%; 
            width: 0; 
          }
  
          .promo {
            display: block; 
            color: #ffffff; 
            text-align: center; 
  
            font-size: 17px;
            line-height: 1.4;
            text-align: left;
            font-weight: 100;
            padding: 1rem;
            padding-right: 2rem;
  
            .promo-intro {
              display: block;
              margin-bottom: 1rem;
            }
            .discount-badge {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
  
              border: 1px dashed white;
              box-shadow: 0 0 0 2px #C42F52, rgba(0,0,0,0.2) 0px 15px 35px 0px, rgba(0,0,0,0.12) 0px 5px 15px 0px;
              background: #C42F52;
              color: white;
              border-radius: 8px;
              padding: 0 0.5rem;
              margin: 0 10px;
            }
          }
          .limited-time {
            font-size: 1rem;
            text-transform: uppercase;
            color: white;
          }
        }
        &__right {
          display: flex; 
          margin-top: 0.25rem; 
          flex-shrink: 0; 
          order: 3; 
          justify-content: center; 
          width: 100%; 
  
          @media (min-width: 640px) { 
            margin-top: 0; 
            margin-right: 3rem; 
            order: 2; 
            width: auto; 
          }
          .pre-deadline {
            display: flex; 
            color: #ffffff; 
            font-size: 1.125rem;
            line-height: 1.75rem; 
            text-transform: uppercase; 
          }
          .flip-count {
            display: flex; 
            color: #333; 
            font-size: 0.875rem;
            line-height: 1.25rem; 
            text-align: center; 
            text-transform: uppercase; 
  
            padding: 1rem;
            background: white;
            border-radius: 12px;
  
            .flip-title {
              font-size: 18px;
            }
            .promo-timer {
              color: #333; 
            }
  
            @media (min-width: 640px) { 
              flex-direction: column; 
            }
            .flip-title {
              margin-bottom: 0.5rem; 
            }
          }
        }
      }
      &.open {
        height: auto;
        .banner--content {
          opacity: 1;
          transform: scale(1);
          transition-delay: 0.5s;
        }
      }
      @media (min-width: 640px) {
        &.open {
          height: auto;
        }
      }
    
      .text-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
</style>